import { useRouter } from 'next/navigation'
import { createNewPage } from '../utils'
import { useEffect, useState } from 'react'
import { UseFormReset, UseFormSetValue } from 'react-hook-form'
import { useProductStore, useUIStore } from '@/store'

interface Props {
  setValue: UseFormSetValue<any>
  reset: UseFormReset<any>
}

export const useFilter = ({ setValue, reset }: Props) => {
  const route = useRouter()
  const [subItems, setSubIntems] = useState<any>([])

  const closeMenu = useUIStore((state) => state.closeSideMenu)
  const totalResult = useProductStore((state) => state.totalResult)

  useEffect(() => {
    if (totalResult) {
      closeMenu()
    }
  }, [totalResult])

  const onSubmit = async (data: any) => {
    const { productSizeId, productWidthId, productHeightId, ...rest } = data

    // console.log('productHeightId', productHeightId)

    const dataFormta = {
      ...rest,
      productSizeId: productSizeId.value.toString(),
      productWidthId: productWidthId.value.toString(),
      productHeightId: productHeightId.value.toString(),
    }

    const urlRedirect: string = createNewPage(dataFormta)
    //console.log('urlRedirect', urlRedirect)
    route.push(urlRedirect)
  }

  const setCategory = (e: any, ele: any) => {
    let categoryName = ele.name
    if (!ele.id) {
      categoryName = ''
      setValue('categoryId', '')
    }

    setSubIntems([...ele.brands])
    setValue('category', categoryName)
  }

  const setBrand = (e: any, ele: any) => {
    //console.log('setBrand value', ele)

    if (!ele.id) {
      setValue('brandId', '')
      return
    }

    setValue('brandId', e.target.value)
    setValue('brand', ele.name)
  }

  const resetButton = () => {
    reset()
  }

  return {
    subItems,
    onSubmit,
    setCategory,
    setBrand,
    resetButton,
  }
}
